import { FC, memo } from 'react'

import { Text, Button } from '@cash-me/react-components'
import NextImage from "next/image"

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { HeroProps } from './hero.model'
import * as S from './styles'

const Hero: FC<HeroProps> = memo(({ onClick }) => {
  const { isMobile } = useWindowSize()

  const BreadcrumbLinks = [
    { label: 'Financiamento para Construção' }
  ]
  
  return (
    <S.Hero>
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.Infos>
            <Breadcrumb items={BreadcrumbLinks} />
            <Text as="h1" size="heading2" weight="medium">
              Financiamento para {' '}
              <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
                Construção
              </Text>
            </Text>
            <Text size="body1" color="var(--colors-neutral-text-weak)">
              Construa ou termine sua obra com crédito de até 50% do valor de avaliação do seu imóvel finalizado.
            </Text>
            {isMobile && 
              <Button
                size="lg"
                onClick={onClick}
              >
                Simular agora
              </Button>
            }
            <S.LoanInfos>
              <S.LoanInfosItem>
                <S.LoanInfosIcon name="ground" color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Terrenos quitados ou com saldo devedor*
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon name="home" color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Casa dentro e fora de condomínio
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <S.LoanInfosIcon name="comercialBuilding" color="var(--colors-cyan-icon-hover)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Imóveis comerciais*
                </Text>
              </S.LoanInfosItem>
            </S.LoanInfos>
            <Text className="disclaimer" color="var(--colors-neutral-text-weak)">
              * sujeitos à análise
            </Text>
            {!isMobile && 
              <Button size="lg" iconName="arrowRight" onClick={onClick}>
                Simular agora
              </Button>
            }
          </S.Infos>
        </Col>
        {!isMobile && 
          <Col col={{ desktop: 5 }}>
            <S.ImageWrapper>
              <S.Image>
                <NextImage
                  src='/images/construction-companies/hero-house.png?updated=230508'
                  alt="Cadeira azul com mesinha e vaso de planta"
                  width="525"
                  height="597"
                  quality={90}
                  priority
                  sizes="100vw"
                  style={{
                    width: "100%",
                    height: "auto"
                  }} />
              </S.Image>
            </S.ImageWrapper>
          </Col>
        }
      </Grid>
    </S.Hero>
  );
})

Hero.displayName = 'Hero'

export default Hero
